var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 100,
    viewBox: "0 0 37.042 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video",
    d: "m34.727 1.2027h-1.0267c-0.60772 0-1.1911 0.24895-1.6252 0.69273l-3.1358 3.2135v-1.5009c0-1.9928-1.5558-3.608-3.4727-3.608h-21.993c-1.9146 0-3.4727 1.6176-3.4727 3.608v19.242c0 1.9916 1.5546 3.608 3.4727 3.608h21.993c1.9169 0 3.4727-1.6164 3.4727-3.608v-1.4684l3.1358 3.2135c0.43409 0.44377 1.0175 0.69273 1.6252 0.69273h1.0267c1.2779 0 2.3151-1.0764 2.3151-2.4053v-19.275c0-1.3289-1.0372-2.4053-2.3151-2.4053zm-31.254 22.85c-0.63897 0-1.1576-0.53999-1.1576-1.2026v-19.242c0-0.66506 0.51743-1.2026 1.1576-1.2026h21.993c0.63781 0 1.1576 0.53879 1.1576 1.2026v19.242c0 0.66266-0.51974 1.2026-1.1576 1.2026zm31.254-1.1702h-1.1576l-4.6302-4.8106v-0.032273l-1.1575-1.2028v-7.2159l5.7878-6.0133h1.1576z",
    fill: "#333",
    strokeWidth: 0.26458
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5e3ca583e31cfa275ed7eb2655b127a5.svg";
export { ForwardRef as ReactComponent };